import { AppBundle } from 'api/optimalprint-sdk.d';
import React from 'react';
import styles from './RecentlyViewedProduct.module.scss';

export interface OwnProps {
  product: AppBundle.Api.Response.Product.V1.RecentlyViewedProductListV1Response.RecentlyViewedItem;
}

const RecentlyViewedProduct = ({ product }: OwnProps) => (
  <a href={product.productUrl} className={styles.recentlyViewedproduct}>
    <img src={product.imageUrl} alt="" />
  </a>
);

export default RecentlyViewedProduct;
